import { Stack } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import _ from 'lodash';
import React from 'react';

interface Props {
  primaryText: string;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
  /** Zweite Zeile rechts vom Hauptknopf, etwa „Neuen Code anfordern". */
  secondaryText?: string;
  secondaryLoading?: boolean;
  /** Links: Zurück oder Abbrechen. Fehlt auf Schritten, die keinen Weg zurück haben. */
  backText?: string;

  onPrimary(): void;

  onSecondary?(): void;

  onBack?(): void;
}

/**
 * Die Aktionszeile eines Schrittes: höchstens ein Weg zurück, höchstens eine
 * Nebenaktion, genau eine Hauptaktion.
 */
const StepActions: React.FC<Props> = ({
  primaryText,
  primaryDisabled,
  primaryLoading,
  secondaryText,
  secondaryLoading,
  backText,
  onPrimary,
  onSecondary,
  onBack,
}) => (
  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={2} flexWrap={'wrap'}>
    <div>{!_.isNil(backText) && !_.isNil(onBack) ? <PaiLink text={backText} size={'md'} action={onBack} /> : null}</div>
    <Stack direction={'row'} alignItems={'center'} gap={1.5} flexWrap={'wrap'} justifyContent={'flex-end'}>
      {!_.isNil(secondaryText) && !_.isNil(onSecondary) ? (
        <PaiButton text={secondaryText} border={'rounded'} color={'secondary'} action={onSecondary} loading={secondaryLoading} />
      ) : null}
      <PaiButton text={primaryText} border={'rounded'} action={onPrimary} loading={primaryLoading} disabled={primaryDisabled} />
    </Stack>
  </Stack>
);

export default StepActions;
